import {brandConfigObjectMap} from "@/brand/brandConfig";
import {getDefaultProductId, getMigrationProductIds} from "@/config";

export const brandConfigMap = new Map();

brandConfigMap.set('http://localhost:8080', getBrandConfig('vc-za-en'));
brandConfigMap.set('https://demo-cricketzone.co.za', getBrandConfig('vc-za-en-demo'));
brandConfigMap.set('https://pk-cricketzone.co.za', getBrandConfig('et-pk-en'));
brandConfigMap.set('https://cricketzone-co-za.migration.penrosesystems.com', getBrandConfig('vc-za-en'));
brandConfigMap.set('https://cricketzone-co-za.migration.penrosesystems.com', getBrandConfig('vc-za-en'));
brandConfigMap.set('https://staging.cricketzone.co.za', getBrandConfig('vc-za-en'));
brandConfigMap.set('https://mtn-cricketzone.co.za', getBrandConfig('mtn-za-en'));
brandConfigMap.set('https://mtn-cricketzone-co-za.migration.penrosesystems.com', getBrandConfig('mtn-za-en'));
brandConfigMap.set('https://wp-cricketzone.co.za', getBrandConfig('wp-za-en'));
brandConfigMap.set('https://wp-cricketzone-co-za.migration.penrosesystems.com', getBrandConfig('wp-za-en'));
brandConfigMap.set('https://bd-gp-cricketzone-club.migration.penrosesystems.com', getBrandConfig('gp-bd-en'));
brandConfigMap.set('https://bd-gp-cricketzone-club.migration.penrosesystems.com', getBrandConfig('gp-bd-en'));

// Add a default fallback configuration
brandConfigMap.set('default', getBrandConfig('vc-za-en'));

export function getBrandConfig(brand) {
    const brandConfigObject = brandConfigObjectMap.get(brand);
    const migrationProductIds = getMigrationProductIds(brand);
    const defaultProductId = getDefaultProductId(brand);
    return {
        brand,
        gameTitle: brandConfigObject.gameTitle,
        freePlayServiceId: brandConfigObject.freePlayServiceId,
        newIntegration: brandConfigObject.newIntegration,
        baseRoute: brandConfigObject.baseRoute,
        productId: defaultProductId ?? brandConfigObject.productId,
        defaultProductId: defaultProductId ?? brandConfigObject.productId,
        productIds: migrationProductIds,
        demoMsisdn: brandConfigObject.demoMsisdn,
        hasBracketGames: brandConfigObject.hasBracketGames
    }
}
